<template>
  <div>
    <home-title title="PRODUCT INTRODUCTION" subTitle="产品介绍" />
    <swiper-comp />
    <product-item />
  </div>
</template>
<script>
import HomeTitle from "../home/homeItemTitle.vue";
import SwiperComp from "./SwiperComp.vue";
import ProductItem from "./ProductItem.vue";
export default {
  name: "ProductHome",
  components: {
    HomeTitle,
    SwiperComp,
    ProductItem,
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/product/ProductHome.vue